export class UserAudit {
  usuario: string;
  usuarioId: number;
  tela: string;

  constructor(item: any, screen: string) {
    this.usuario = item.name;
    this.usuarioId = item.userId;
    this.tela = screen;
  }
}
